export * from './generated/types';

export interface IUserCurrentLocaleCache {
  country: string;
  expiration: Date;
}
